module.exports = __webpack_public_path__ + "static/quizz.00a9cea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Viewport/quizz.png
// module id = 676
// module chunks = 213534597649335